import { forEach, set, get } from 'lodash'
import extractDataValue from './extract-data-value'
import postcss from 'postcss'
import shorthandExpand from './postcss/postcss-shorthand-expand'
import getHash from 'Functions/get-hash'

// Note: Cachig library memoize.

const cachedResultForExpandShorthandFn = {}

// https://jsbin.com/wefatehuro/edit?html,js,console
function expandShorthandCssProperties( code = '' ) {

	// Stupid simple function caching.
	// Return cached value if the same code already processed.
	const codeHash = getHash( code )
	if ( codeHash in cachedResultForExpandShorthandFn ) {
		return cachedResultForExpandShorthandFn[ codeHash ]
	}

	code = postcss( [ shorthandExpand() ] ).process( code ).css

	// Cache result.
	cachedResultForExpandShorthandFn[ codeHash ] = code

	return code
}

// ============================================================

const cachedAllValuesBySelector = {}

// Function used as custom PostCSS filter to extract all CSS values by selector.
function cacheAllCssValuesBySelector( { cssSelector } ) {
	// Documentation: http://api.postcss.org/
	return ( root, result ) => {
		// https://regex101.com/r/vRUjj2/11
		const selectorRegex = new RegExp( "(?:^\\s*|,\\s*)" + window.stlst_legacy.prepare_regex_string( cssSelector ) + "(?:\\s*,|\\s*$)", "m" )
		// ↑ don't use "g" (global) key in the regex above!
		//				↓ Filter	 ↓ Callback
		root.walkRules( selectorRegex, ( rule, index ) => {
			root.walkDecls( decl => {
				let currentSize = 'desktop'
				// Check if we have any mediaQueries as grand-parent rule?
				if ( "atrule" === decl.parent.parent.type &&
					"media" === decl.parent.parent.name ) {
					currentSize = decl.parent.parent.params
				}
				// Save value into the resulting cache object.
				// cachedAllValuesBySelector.responsiveSize.cssSelector.cssProperty = cssValue.
				set( cachedAllValuesBySelector, currentSize + '["' + cssSelector + '"]' + decl.prop, decl.value  )

			} )
		} )
	}
}

// ============================================================


let getCssValueCachedResults = {}

export default function getCssValue( {
	cssSelector = window.Stylist.cssSelectorCustom,
	cssProperty,
	responsiveSize = window.stlst_legacy.get_media_condition(),
	cssCode = window.Stylist.codeEditor.getValue(),
	check = false } ) {

	return getCssValueAcync( {
		cssSelector:cssSelector,
		cssProperty: cssProperty,
		responsiveSize: responsiveSize,
		cssCode: cssCode,
		check: check,
	} )
}

/**
 * Get inserted (our custom) style by selector and rule.
 */

async function getCssValueAcync( {
	cssSelector = window.Stylist.cssSelectorCustom,
	cssProperty,
	responsiveSize = window.stlst_legacy.get_media_condition(),
	cssCode = window.Stylist.codeEditor.getValue(),
	check = false } ) {
	// Defaults
	let dataContent = '',
		hasInFullCSS = false

	// Stupid simple function caching.
	// Return cached value if the same code already processed.
	const codeHash = getHash( cssCode )
	const selectorHash = getHash( cssSelector )
	const cacheId = codeHash + selectorHash

	// If calculation were already made for current unique code and selector:
	if ( cacheId in getCssValueCachedResults ) {
		const cachedValue = get( getCssValueCachedResults, cacheId + '["' + responsiveSize + '"]' + '["' + cssSelector + '"]' + '["' + cssProperty + '"]', false )
		console.log( "✅ getCssValue:" ); console.log( cssProperty + ':' + cachedValue );
		return cachedValue
	}

	console.log( "NO CACHED VALUE: ❌❌❌❌" );

	return await cacheCssValuesForSelector( {
		cssSelector: cssSelector,
		cssCode: cssCode } ).then( ( value ) => {
		if ( value ) {
			// By this point cachedAllValuesBySelector filled with data,
			// so we can set it as a value for getCssValueCachedResults[cacheId]:
			set( getCssValueCachedResults, cacheId, cachedAllValuesBySelector )
			const cachedValue = get( getCssValueCachedResults, cacheId + '["' + responsiveSize + '"]' + '["' + cssSelector + '"]' + '["' + cssProperty + '"]', false )
			console.log( "❌ getCssValue:" ); console.log( cssProperty + ':' + cachedValue );
			return cachedValue
		} // else:
		console.warn( 'Error 11:59 – can not cache css values for selector ' + cssSelector + ' using PostCSS.' );
	} )

	console.log( "cached:" ); console.log( cached );

	/**
	 * POSTCSS PLUGIN: shorthandExpand
	 * Replace all compounded rules like margin: XX XX XX XX
	 * into full-lenght properties like maring-right, margin-top, etc.
	 *
	 * POSTCSS PLUGIN: cacheAllCssValuesBySelector
	 * Compose an object (cachedAllValuesBySelector) with all properties
	 * for the proided selector.
	 */
	/* postcss( [
		shorthandExpand(),
		cacheAllCssValuesBySelector( {
			cssSelector: cssSelector
		} )
	] ).process( cssCode ).then( result => {
		// By this point cachedAllValuesBySelector filled with data,
		// so we can set it as a value for getCssValueCachedResults[cacheId]:
		set( getCssValueCachedResults, cacheId, cachedAllValuesBySelector )
		// console.log( "🎁🎁🎁🎁 getCssValueCachedResults:" ); console.log( getCssValueCachedResults );
		const cachedValue = get( getCssValueCachedResults, cacheId + '["' + responsiveSize + '"]' + '["' + cssSelector + '"]' + '["' + cssProperty + '"]', false )
		console.log( "❌ getCssValue:" ); console.log( cssProperty + ':' + cachedValue );
		return cachedValue
	} ) */
}

export const cacheCssValuesForSelector = ( {
	cssSelector = window.Stylist.cssSelectorCustom,
	cssCode = window.Stylist.codeEditor.getValue() } ) => {

	return new Promise( ( resolve, reject ) => {
		// Stupid simple function caching.
		// Return cached value if the same code already processed.
		const cacheId = getHash( cssCode ) + getHash( cssSelector )

		// Check if already cached for current code + selector combination.
		if ( cacheId in getCssValueCachedResults ) {
			const cachedValue = get( getCssValueCachedResults, cacheId, false )
			if	( cachedValue ) {
				resolve( true )
			}
		}

		console.log( "NO CACHED VALUE: ❌❌❌❌" );

		/**
		 * POSTCSS PLUGIN: shorthandExpand
		 * Replace all compounded rules like margin: XX XX XX XX
		 * into full-lenght properties like maring-right, margin-top, etc.
		 *
		 * POSTCSS PLUGIN: cacheAllCssValuesBySelector
		 * Compose an object (cachedAllValuesBySelector) with all properties
		 * for the proided selector.
		 */
		postcss( [
			shorthandExpand(),
			cacheAllCssValuesBySelector( {
				cssSelector: cssSelector
			} )
		] ).process( cssCode ).then( result => {
			// By this point cachedAllValuesBySelector filled with data,
			// so we can set it as a value for getCssValueCachedResults[cacheId]:
			set( getCssValueCachedResults, cacheId, cachedAllValuesBySelector )
			const cachedValue = get( getCssValueCachedResults, cacheId, false )
			if	( cachedValue ) {
				resolve( true )
			} else {
				reject( false )
			}
		} )
	} )
}



// WEBPACK FOOTER //
// ./dev/stylist_parent/functions/get-css-value.js